/**
 * Drawer localization schema.
 * Defines all translation strings for the navigation drawer sections and items.
 *
 * @drawer_header @app_name Display name of the application in the drawer header.
 * @drawer_sections @section @title Section title displayed in the drawer (optional in rail mode).
 * @drawer_sections @section @drawer_items @title title Drawer item visible title.
 * @drawer_sections @section @drawer_items @tooltip_text Drawer item tooltip shown on hover.
 */
export default {
  // Drawer Header
  alerts: {
    app_name: "Iris",

    // Info Alert
    info_alert: {
      title: "There is no data.",
      description: "IrisFE could not download the requested information.",
    },
  },

  drawer_sections: {
    // Overview Section
    overview_section: {
      // Section Title
      title: "overview",

      // Overview Items
      drawer_items: {
        channels: {
          title: "Channels",
          tooltip_text: "Channels Overview",
        },
        validation: {
          title: "Validation",
          tooltip_text: "Validation Overview",
        },
      },
    },

    // About Section
    about_section: {
      // About Items
      drawer_items: {
        about: {
          title: "About",
          tooltip_text: "About This Application",
        },
      },
    },
  },
};
